import { gql } from '@apollo/client';

const PartnerUserInfoShared = gql`
  fragment PartnerUserInfoShared on PartnerUser {
    id
    firstName
    lastName
    email
    emailDeliverabilityStatus
    phone
    language
    roleTypeId
    state
    discarded
    discardedAt
    partnerLocation {
      id
      name
    }
    partnerLocationId
    partnerOrganizationId
    partnerOrganization {
      id
      name
    }
    roleType {
      id
      name
    }
    imageUrl
    lastLoginAt
    createdAt
    updatedAt
  }
`;

export default PartnerUserInfoShared;
